import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remounts its children on every route change, so the page plays its enter animation.
 * The key is the pathname only: query/hash changes (filters, tabs) must not replay it.
 */
const RouteTransition = ({ children }) => {
    const { pathname } = useLocation();
    return (
        <div key={pathname} className="route-enter">
            {children}
        </div>
    );
};

export default RouteTransition;
